import { render } from "./edit-video.vue?vue&type=template&id=71a5bc7f"
import script from "./edit-video.vue?vue&type=script&lang=js"
export * from "./edit-video.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__